import { configureStore } from '@reduxjs/toolkit';
import noticesReducer from './reducers/notices';
import quickPayReducer from './reducers/quickPay';
import termsAndConditionsReducer from './reducers/termsAndConditions';
export const basketStore = {
    reducer: {
        notices: noticesReducer,
        quickPay: quickPayReducer,
        termsAndConditions: termsAndConditionsReducer,
    },
};
const store = configureStore(basketStore);
export default store;
